/* eslint-disable import/order */
import { i18n } from '@/plugins/i18n'
import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import Vue from 'vue'
import App from './App.vue'
import './plugins/acl'
import './plugins/non-negative'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// Адрес сервера для ссылок на документы и файлы (/static/, /media/) — тот же,
// что у API; раньше в шаблонах был зашит backrequests.atg-service.info, и
// 19.10.2026, когда тот домен истёк у регистратора, все ссылки умерли разом.
Vue.prototype.$serverUrl = process.env.VUE_APP_API_URL

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app')
